// ERP Attribute Engine — Form Store (Zustand)
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useFormStore = create(
  persist(
    (set, get) => ({
      solutionId: 'apparel',
      role: 'admin',
      values: {},
      errors: {},
      isDirty: false,
      isSubmitting: false,
      lastSaved: null,
      draftValues: {},
      globalValues: {},
      solutionValues: {},

      setSolution: (id) => {
        const { values, solutionId, draftValues, solutionValues } = get();
        set({
          solutionId: id,
          values: {
            ...(draftValues[id] ?? {}),
            ...(solutionValues[id] ?? {}),
            ...get().globalValues
          },
          errors: {},
          isDirty: false,
          draftValues: { ...draftValues, [solutionId]: values },
        });
      },

      setRole: (role) => set({ role }),

      setFieldValue: (fieldId, value, scope = 'form') =>
        set(state => {
          const nextValues = { ...state.values, [fieldId]: value };
          const nextGlobal = scope === 'global'
            ? { ...state.globalValues, [fieldId]: value }
            : state.globalValues;
          const nextSolution = scope === 'solution'
            ? { ...state.solutionValues, [state.solutionId]: { ...(state.solutionValues[state.solutionId] ?? {}), [fieldId]: value } }
            : state.solutionValues;
          return {
            values: nextValues,
            globalValues: nextGlobal,
            solutionValues: nextSolution,
            isDirty: true,
            errors: Object.fromEntries(Object.entries(state.errors).filter(([k]) => k !== fieldId)),
          };
        }),

      setErrors: (errors) => set({ errors }),
      clearErrors: () => set({ errors: {} }),

      saveDraft: () => {
        const { values, solutionId, draftValues } = get();
        set({ draftValues: { ...draftValues, [solutionId]: values }, lastSaved: new Date(), isDirty: false });
      },

      resetForm: () => set({ values: {}, errors: {}, isDirty: false }),
      setSubmitting: (val) => set({ isSubmitting: val }),
    }),
    {
      name: 'erp-form-engine-v1',
      partialize: (state) => ({ draftValues: state.draftValues, solutionId: state.solutionId, role: state.role }),
    }
  )
);

let _timer = null;
export function startAutoSave(intervalMs = 30000) {
  if (_timer) clearInterval(_timer);
  _timer = setInterval(() => {
    const { isDirty, saveDraft } = useFormStore.getState();
    if (isDirty) saveDraft();
  }, intervalMs);
}
export function stopAutoSave() {
  if (_timer) { clearInterval(_timer); _timer = null; }
}
